<template>
  <div class="home">
    <h2>Combinations</h2>

    <b-button
      @click="raisePopup({ target: $event.target })"
      variant="primary"
      :hidden="
        this.$store.state.user.role === 'tester' && !this.$store.state.officeIp
      "
    >
      Add new
    </b-button>

    <b-container
      class="block"
      :hidden="this.$store.state.user.role === 'tester'"
    >
      <b-form-input
        v-model="ipAddress"
        placeholder="Enter office ip"
        md="3"
        class="officeIp"
      />
      <b-button @click="updateOfficeIp()" variant="primary">
        Change office IP
      </b-button>
    </b-container>
    <!-- Info modal -->
    <b-modal
      id="combinationsModal"
      v-bind:title="this.isEdit ? 'Edit combination' : 'New combination'"
      @ok="combinationFormSubmit"
    >
      <b-form>
        <input id="newCombinationInput0" type="hidden" v-model="form.id" />
        <b-form-group
          id="newCombinationInputGroup1"
          label="Platform:"
          label-for="newCombinationInput1"
        >
          <b-form-select
            id="newCombinationInput1"
            v-model="form.platformId"
            :options="platformItems()"
          ></b-form-select>
        </b-form-group>

        <b-form-group
          id="newCombinationInputGroup2"
          label="Whitelabel:"
          label-for="newCombinationInput2"
        >
          <b-form-select
            id="newCombinationInput2"
            v-model="form.whitelabelId"
            :options="whitelabelItems()"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          id="newCombinationInputGroup3"
          label="Build ID:"
          label-for="newCombinationInput3"
        >
          <b-form-input
            id="newCombinationInput3"
            type="number"
            v-model="form.buildId"
            required
            placeholder="Enter Build ID"
          />
        </b-form-group>

        <b-form-group
          id="newCombinationInputGroup4"
          label="App Install ID:"
          label-for="newCombinationInput4"
        >
          <b-form-input
            id="newCombinationInput4"
            type="text"
            v-model="form.appInstallId"
            placeholder="Enter unique app installation ID"
          />
        </b-form-group>

        <b-form-group
          id="newCombinationInputGroup5"
          label="IP address:"
          label-for="newCombinationInput5"
        >
          <b-form-input
            id="newCombinationInput5"
            type="text"
            v-model="form.ipAddress"
            placeholder="Enter IP address"
            :disabled="this.$store.state.user.role === 'tester'"
          />
        </b-form-group>

        <b-form-group
          id="newCombinationInputGroup6"
          label="Custom build URLs:"
          label-for="newCombinationInput6"
        >
          <b-form-input
            id="newCombinationInput6"
            type="text"
            v-model="form.customBuildUrls"
            placeholder='Enter custom urls to load. Format `["url1", "url2", "..."]`'
          />
        </b-form-group>

        <b-form-group
          id="newCombinationInputGroup7"
          label="Description:"
          label-for="newCombinationInput7"
        >
          <b-form-input
            id="newCombinationInput7"
            type="text"
            v-model="form.description"
            placeholder="Enter description"
          />
        </b-form-group>

        <b-form-group id="newCombinationGroup4">
          <b-form-checkbox v-model="formForceLocalBuild"
            >Force local build?</b-form-checkbox
          >
          <b-form-checkbox v-model="formIsPublished"
            >Is combination published?</b-form-checkbox
          >
        </b-form-group>
      </b-form>
    </b-modal>

    <b-container fluid>
      <b-row>
        <b-col md="12" class="my-1">
          <b-form-group label-cols-sm="1" label="Filter" class="mb-0">
            <b-input-group>
              <b-form-input
                v-model="filter.appInstallId"
                placeholder="by AppInstallId"
                @keypress.enter="forceFilter"
              />
              <b-form-select
                v-model="filter.platformId"
                placeholder="by Platform"
                :options="platformItems()"
              ></b-form-select>
              <b-form-input
                v-model="filter.ipAddress"
                placeholder="by IP"
                @keypress.enter="forceFilter"
              />
              <b-form-select
                v-model="filter.whitelabelId"
                placeholder="by Whitelabel"
                :options="whitelabelItems()"
              ></b-form-select>
              <b-form-input
                v-model="filter.buildId"
                placeholder="by Builds"
                @keypress.enter="forceFilter"
              />
              <b-input-group-append>
                <b-button
                  :disabled="
                    !filter.appInstallId &&
                      !filter.platformId &&
                      !filter.ipAddress &&
                      !filter.whitelabelId &&
                      !filter.buildId
                  "
                  @click="
                    filter = {};
                    forceFilter();
                  "
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- User Interface controls -->
      <!--<b-row>-->
      <!--<b-col md="12" class="my-1">-->
      <!--<b-form-group label-cols-sm="1" label="Filter" class="mb-0">-->
      <!--<b-input-group>-->
      <!--<b-form-input v-model="filter" placeholder="Type to Search" />-->
      <!--<b-input-group-append>-->
      <!--<b-button :disabled="!filter" @click="filter = ''"-->
      <!--&gt;Clear</b-button-->
      <!--&gt;-->
      <!--</b-input-group-append>-->
      <!--</b-input-group>-->
      <!--</b-form-group>-->
      <!--</b-col> </b-row>-->
      <b-row>
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="2" label="Sort" class="mb-0">
            <b-input-group>
              <b-form-select v-model="sortBy" :options="sortOptions">
                <option slot="first" :value="null">-- none --</option>
              </b-form-select>
              <b-form-select
                :disabled="!sortBy"
                v-model="sortDesc"
                slot="append"
              >
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-table
        show-empty
        small
        hover
        stacked="md"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        ref="combinationsTable"
        class="combinationsTable"
      >
        <template v-slot:cell(customBuildUrls)="row">
          <div v-b-popover.hover="`${row.value}`">
            {{ row.value ? `${row.value.slice(0, 50)}...` : '' }}
          </div>
        </template>

        <template v-slot:cell(isPublished)="row">
          {{ row.value ? 'Yes' : 'No' }}
        </template>
        <template v-slot:cell(forceLocalBuild)="row">
          {{ row.value ? 'Yes' : 'No' }}
        </template>
        <template v-slot:cell(whitelabelId)="row">
          {{ `${row.value} (${row.item['whitelabel.name']})` }}
        </template>
        <template v-slot:cell(platformId)="row">
          {{ `${row.value} (${row.item['platform.name']})` }}
        </template>
        <template v-slot:cell(buildId)="row">
          {{ `${row.value} (${row.item['build.name']})` }}
        </template>

        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            class="m-1"
            @click="row.toggleDetails"
            variant="info"
          >
            …
          </b-button>
          <b-button
            size="sm"
            class="m-1"
            variant="warning"
            @click="
              raisePopup({
                target: $event.target,
                isEdit: true,
                combination: row.item
              })
            "
          >
            ✎
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            class="m-1 ml-3"
            @click="
              deleteCombination({
                target: $event.target,
                combination: row.item
              })
            "
          >
            X
          </b-button>
        </template>

        <template v-slot:row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">
                {{ key }}: {{ value }}
              </li>
            </ul>
          </b-card>
        </template>
      </b-table>

      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable no-magic-numbers */
export default {
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100, 500],
      sortBy: null,
      sortDesc: false,
      filter: {
        appInstallId: '',
        platformId: null,
        ipAddress: '',
        whitelabelId: null,
        buildId: ''
      },
      form: {
        id: null,
        platformId: null,
        whitelabelId: null,
        buildId: null,
        isPublished: null,
        forceLocalBuild: null,
        appInstallId: null,
        ipAddress: null,
        customBuildUrls: null,
        description: ''
      },
      ipAddress: null,
      isEdit: false
    };
  },
  computed: {
    formForceLocalBuild: {
      get: function() {
        return !!this.form.forceLocalBuild;
      },
      set: function(newValue) {
        this.form.forceLocalBuild = newValue;
      }
    },
    formIsPublished: {
      get: function() {
        return !!this.form.isPublished;
      },
      set: function(newValue) {
        this.form.isPublished = newValue;
      }
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    fields() {
      return [
        {
          key: 'id',
          label: 'id',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'appInstallId',
          label: 'App Install ID',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'whitelabelId',
          label: 'Whitelabel',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'platformId',
          label: 'Platform',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'buildId',
          label: 'Build',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'ipAddress',
          label: 'IP Address',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'customBuildUrls',
          label: 'Custom URLs',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'description',
          label: 'Description',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'forceLocalBuild',
          label: 'Force local?',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'isPublished',
          label: 'Is published?',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'createdAt',
          label: 'Created',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'updatedAt',
          label: 'Updated',
          sortable: true,
          class: 'text-center'
        },
        { key: 'actions', label: 'Actions' }
      ];
    },
    totalRows() {
      return this.$store.state.combinations.count;
    }
  },
  methods: {
    raisePopup({ target, isEdit = false, combination = null }) {
      this.isEdit = isEdit;
      if (combination && isEdit) {
        this.form = Object.keys(this.form).reduce(
          (acc, current) =>
            combination[current]
              ? {
                  ...acc,
                  [current]: String(combination[current])
                }
              : acc,
          {}
        );
      } else {
        this.combinationFormReset();
      }
      this.$root.$emit('bv::show::modal', 'combinationsModal', target);
    },
    forceFilter() {
      this.onFiltered();
      this.$refs.combinationsTable.refresh();
    },
    deleteCombination({ combination = null }) {
      if (!combination) {
        return;
      }
      const promise = this.$store.dispatch('deleteCombination', combination.id);

      // Must return a promise that resolves to an array of items
      return promise.then(() => {
        this.$refs.combinationsTable.refresh();
      });
    },
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.currentPage = 1;
    },
    items(ctx) {
      const currentFilter = Object.keys(this.filter).reduce(
        (acc, curr) =>
          this.filter[curr] ? { ...acc, [curr]: this.filter[curr] } : acc,
        {}
      );
      const promise = this.$store.dispatch('getCombinations', {
        ctx,
        filter: currentFilter
      });

      // Must return a promise that resolves to an array of items
      return promise.then(() => {
        // Pluck the array of items off our axios response
        const items = this.$store.state.combinations.rows.map(comb => {
          if (comb.isPublished) {
            comb._rowVariant = 'success';
          }
          return comb;
        });
        // Must return an array of items or an empty array if an error occurred
        return items || [];
      });
    },
    combinationFormReset() {
      this.form = {
        id: null,
        platformId: null,
        whitelabelId: null,
        buildId: null,
        isPublished: null,
        forceLocalBuild: null,
        appInstallId: null,
        ipAddress:
          this.$store.state.user.role === 'tester'
            ? this.$store.state.officeIp
            : null,
        customBuildUrls: null,
        description: ''
      };
    },
    async combinationFormSubmit(event) {
      if (!this.isEdit) {
        await this.$store.dispatch('addCombination', {
          combination: this.form,
          event
        });
      } else {
        await this.$store.dispatch('editCombination', {
          combination: this.form,
          event
        });
      }

      this.combinationFormReset();
      this.$refs.combinationsTable.refresh();
    },
    getOfficeIp() {
      const promise = this.$store.dispatch('getOfficeIp');
      return promise.then(res => {
        const ip = res?.data?.data?.ip;

        if (ip) {
          if (this.$store.state.user.role === 'tester') {
            this.form.ipAddress = ip;
          } else {
            this.ipAddress = ip;
          }
        }
      });
    },
    updateOfficeIp() {
      this.$store
        .dispatch('updateOfficeIp', {
          ip: this.ipAddress
        })
        .catch(() => this.getOfficeIp());
    },
    getWhitelabels() {
      return this.$store
        .dispatch('getWhitelabels', {
          sortDesc: false,
          currentPage: 1,
          perPage: 1000
        })
        .then(() => {});
    },
    getPlatforms() {
      return this.$store
        .dispatch('getPlatforms', {
          sortDesc: false,
          currentPage: 1,
          perPage: 1000
        })
        .then(() => {});
    },
    whitelabelItems() {
      return [
        { value: null, text: 'Select Whitelabel' },
        ...(this.$store.state.whitelabels.rows
          ? this.$store.state.whitelabels.rows
              .map(wl => ({
                value: wl.id,
                text: wl.name
              }))
              .sort((a, b) => {
                if (a.text < b.text) {
                  return -1;
                }
                if (a.text > b.text) {
                  return 1;
                }
                return 0;
              })
          : [])
      ];
    },
    platformItems() {
      return [
        { value: null, text: 'Select Platform' },
        ...(this.$store.state.platforms.rows
          ? this.$store.state.platforms.rows
              .map(pl => ({
                value: pl.id,
                text: pl.name
              }))
              .sort((a, b) => {
                if (a.text < b.text) {
                  return -1;
                }
                if (a.text > b.text) {
                  return 1;
                }
                return 0;
              })
          : [])
      ];
    }
  },
  created: function() {
    this.getOfficeIp();
    this.getWhitelabels();
    this.getPlatforms();
  }
};
</script>
<style scoped type="text/scss">
.container {
  max-width: none;
}
.combinationsTable {
  font-size: 0.8rem;
}
.btn {
  font-size: 0.8rem;
}

td[data-label='Actions'] {
  white-space: nowrap;
}

.block {
  display: inline-block;
  max-width: 304px;
  border: 2px solid #cccccc;
  padding: 5px;
  margin-left: 5px;
}

.officeIp {
  display: inline-block;
  width: 160px;
  margin-right: 5px;
}
</style>
